import React from 'react';
import RawEntry from "../components/RawEntry";
import Entry from '../components/Entry';
import EntryConfig from '../components/entryconfigType';
import { Routes, Route } from "react-router-dom";
import '../Default.css';
import type City from './placesType';
import PlaceRender from './PlaceRender'
import Place from './placesType';

const types = {
    "art": "/icons/masks-theater-solid.svg",
    "historic": "/icons/landmark-solid.svg",
    "fotoplace": "/icons/camera-retro-solid.svg",
    "food": "/icons/pizza-slice-solid.svg",
    "nature": "/icons/leaf-solid.svg",
    "default": "/icons/location-dot-solid.svg"
}


function CitiesRenderMenu(city: City) {
    return (
      <>
        <div className="page-title">
          {city.name}
        </div>
        <div className="navigation-wraper">
            <nav className='small-nav-bar navigation-bar'>
              {
              city.description && <Entry conf={ //TODO WTF
                {
                  //@ts-ignore
                  img: city.img.src,
                  img_alt: city.name,
                  link: `./${city.name}`,
                  text: city.name
                } as EntryConfig} />
              }
              {city.places.map((entry, index) => <Entry conf={
                {
                  //@ts-ignore
                  img: types[entry.type],
                  img_alt: entry.type,
                  link: `./${index}`,
                  text: entry.name
                } } key={index}/>
              )}
            </nav>
        </div>
      </>
    );
}

function CitiesRender({city}:{city: City}) {
  return (
    <div className='places'>
        <Routes>
          <Route path='/' element={CitiesRenderMenu(city)}></Route>
          {city.description &&
            <Route path={`/${city.name}`} key={city.name.toString()} element={<PlaceRender place={{
              name: city.name,
              type: city.name,
              page: city.description,
              location: {
                pos: [0, 0],
                info: ""
              },
              copyright: city.copyright
            } as Place} />}/>
          }
          {city.places.map((entry,index) => 
            <Route path={`/${index}`} key={index.toString()} element={<PlaceRender place={entry} key={index} />}/>
          )}
        </Routes>
    </div>
  );
}

export default CitiesRender;